import React from "react";
import SaleDaysLeft from "./SaleDaysLeft";
import "./SaleLabel.scss";

export default function SaleLabel(props) {
  const { name, tagline, recognizable_brand } = props.details;
  const title = recognizable_brand ? name : tagline;
  const tagLine = recognizable_brand ? tagline : name;

  return (
    <div className="top-sales-tile-label">
      <div className="top-sales-tile-title">{title}</div>
      <div className="top-sales-tile-tagline">{tagLine}</div>
      <SaleDaysLeft details={props.details} />
    </div>
  );
}
